import useLiveChatTracking from 'app/modules/live-chat/hooks/useLiveChatTracking';
import { MouseEvent, useCallback } from 'react';

import useLinkClickCapture, { LinkType } from './useLinkClickCapture';

export default function useLiveChatLinkClickCapture() {
  const defaultCapture = useLinkClickCapture();
  const { captureLinkClicked } = useLiveChatTracking();

  return useCallback(
    (event: MouseEvent) => {
      const link = (event.target as HTMLElement).closest('a');
      if (!link) return;

      const wasLinkClickCaptured = defaultCapture(event);

      if (!wasLinkClickCaptured) {
        queueMicrotask(() => {
          captureLinkClicked(LinkType.URL, link.href);
        });
      }
    },
    [captureLinkClicked, defaultCapture]
  );
}
